import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CustomButton from "../../../components/CustomButton";

const PromptUnusualW2 = ({ show, onConfirm, onCancel, isTotalOrCity }: any) => {
  return (
    <Modal
      disableAutoFocus
      open={show}
      onClose={() => onCancel()}
      aria-labelledby="confirm-w2-modal"
      className={'modal-container'}
    >
      <div className={'modal-paper'}>
        <Box component="h3" m={1} className={'modal-title'}>
          We've detected an unusual W-2 form
        </Box>
        <p className={'modal-sub-title'}>
            This is an unusual W-2.&nbsp;
            {isTotalOrCity ? 
            `You will need some guidance to properly enter the wage 
            data into LIME. Please ` :
            `Please compare the amounts showing in boxes 1 and 5 on your W-2 with the amounts showing in boxes 1 and 5 on screen and make any corrections necessary. If the amounts on your W-2 match what’s showing here on screen, please `}
            contact LIME Support at <b>{import.meta.env.VITE_APP_SAAS_CUSTOMER_PHONE}&nbsp;</b>
            for assistance. If you are calling after business hours, 
            a representative will return your call the following business day.</p>
        <Box className={'modal-button-container'}>
          <CustomButton
            variant="contained"
            disableElevation={true}
            label={"OK"}
            onClick={() => onConfirm()}
          />
        </Box>
      </div>
    </Modal>
  );
};

export default PromptUnusualW2;
